import { render } from "./RoamingTeamView.vue?vue&type=template&id=2f6e9211"
import script from "./RoamingTeamView.vue?vue&type=script&lang=js"
export * from "./RoamingTeamView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__